(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jf-product-thumbnails"] && !Shopify.designMode) return;
  try {
    (function () {
    function makeArrow(original) {
      var arrow = original.cloneNode(true);
      arrow.removeAttribute('on:click');
      arrow.removeAttribute('ref');
      arrow.removeAttribute('disabled');
      arrow.classList.add('jf-thumb-arrow');
      arrow.addEventListener('click', function (event) {
        event.preventDefault();
        original.click();
      });
      return arrow;
    }

    // Kopiér det store billedes pil 1:1: ikonstørrelse, stregtykkelse og farve.
    function matchArrow(arrow, original) {
      var o = getComputedStyle(original);
      arrow.style.color = o.color;
      var stroke = o.getPropertyValue('--icon-stroke-width');
      if (stroke) arrow.style.setProperty('--icon-stroke-width', stroke.trim());

      var oWrap = original.querySelector('.svg-wrapper');
      var nWrap = arrow.querySelector('.svg-wrapper');
      var oIcon = original.querySelector('svg');
      var nIcon = arrow.querySelector('svg');

      if (oWrap && nWrap) {
        var w = getComputedStyle(oWrap);
        if (parseFloat(w.width) > 0) {
          nWrap.style.width = w.width;
          nWrap.style.height = w.height;
        }
      }
      if (oIcon && nIcon) {
        var s = getComputedStyle(oIcon);
        if (parseFloat(s.width) > 0) {
          nIcon.style.width = s.width;
          nIcon.style.height = s.height;
        }
      }
    }

    // Skjul pilene, mål om miniaturerne kan være i rækken uden at scrolle,
    // og vis dem kun igen, hvis der ikke er plads.
    function updateVisibility(controls) {
      var container = controls.querySelector('.slideshow-controls__thumbnails-container');
      var arrows = controls.querySelectorAll('.jf-thumb-arrow');
      if (!container || !arrows.length) return;

      arrows.forEach(function (arrow) { arrow.classList.add('jf-thumb-arrow--hidden'); });

      var tooMany = container.scrollWidth > container.clientWidth + 2;

      if (tooMany) {
        arrows.forEach(function (arrow) { arrow.classList.remove('jf-thumb-arrow--hidden'); });
      }
    }

    function setup(root) {
      var configs = (root || document).querySelectorAll('.jf-thumbs-config[data-arrows="true"]');

      configs.forEach(function (config) {
        var media = config.parentElement;
        if (!media) return;

        var auto = config.getAttribute('data-arrows-auto') === 'true';

        media.querySelectorAll('slideshow-controls[thumbnails][pagination-position="center"]').forEach(function (controls) {
          var container = controls.querySelector('.slideshow-controls__thumbnails-container');
          var slideshow = controls.closest('slideshow-component');
          if (!container || !slideshow) return;

          var prev = slideshow.querySelector('.slideshow-control--previous:not(.jf-thumb-arrow)');
          var next = slideshow.querySelector('.slideshow-control--next:not(.jf-thumb-arrow)');
          if (!prev || !next) return;

          if (!controls.querySelector('.jf-thumb-arrow')) {
            controls.insertBefore(makeArrow(prev), container);
            container.after(makeArrow(next));
          }

          var ownPrev = controls.querySelector('.jf-thumb-arrow.slideshow-control--previous');
          var ownNext = controls.querySelector('.jf-thumb-arrow.slideshow-control--next');
          if (ownPrev) matchArrow(ownPrev, prev);
          if (ownNext) matchArrow(ownNext, next);

          if (!auto) {
            controls.querySelectorAll('.jf-thumb-arrow').forEach(function (arrow) {
              arrow.classList.remove('jf-thumb-arrow--hidden');
            });
            return;
          }

          updateVisibility(controls);

          if (controls.dataset.jfObserved) return;
          controls.dataset.jfObserved = 'true';

          var width = controls.clientWidth;
          if ('ResizeObserver' in window) {
            new ResizeObserver(function () {
              if (controls.clientWidth === width) return;
              width = controls.clientWidth;
              updateVisibility(controls);
            }).observe(controls);
          } else {
            window.addEventListener('resize', function () { updateVisibility(controls); });
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setup(document); });
    } else {
      setTimeout(function () { setup(document); }, 0);
    }

    window.addEventListener('load', function () { setup(document); });

    document.addEventListener('shopify:section:load', function (event) {
      setTimeout(function () { setup(event.target); }, 0);
    });
    document.addEventListener('shopify:block:select', function () {
      setTimeout(function () { setup(document); }, 0);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
